export const COMPONENT_NAME = 'GenericMap';
